const styles = () => ({
  container: {
    maxWidth: '800px',
    width: '95%',
    margin: '80px auto 40px',
    border: '1px solid #ebebeb',
    borderRadius: '8px'
  },
  modalHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  modalContent: {
    backgroundColor: '#fff',
    padding: 0,
    '& p': {
      fontSize: '16px',
      lineHeight: '22px'
    }
  },
  footer: {
    display: 'flex',
    justifyContent: 'flex-end'
  }
})

export default styles
